import { useLazyQuery } from '@apollo/client'
import classNames from 'classnames'
import moment from 'moment'
import React, { memo, useEffect, useRef, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import Moment from 'react-moment'

import IconViewEmailByAMS from 'assets/images/icon-email.svg'

import { isAxiosError } from 'axios'
import Loading from 'components/loading'
import ButtonBase from 'components/partials/button'
import { notify } from 'components/toastify'
import { styleJsonPacket } from 'constants/common'
import { MESSAGES, STATUS } from 'constants/messages'
import axiosInstance from 'network/axiosClient'
import DateFilterPicker from 'pages/developer-portal/table/activities-log/component/dateFilterPicker'
import SearchInput from 'pages/principal-account-management/components/searchInput'
import { GET_RECEIVED_TEXT_QUERY, LOAD_LIST_TEMPLATE_SMS } from 'queries/adminPortal'
import { tableHeaderReceivedTxtHistoryTable } from './headers'
import TotalNumberInTable from 'components/partials/totalNumberInTable'
import ChatContentItemDialog, { ISMSTemplateFile } from 'pages/email-system-management/components/chat-screen'
const PAGINATION_DEFAULT = {
  take: 20,
  skip: 0,
}
interface Props {
  setIsRefetchList: (refetchUser: boolean) => void
  isRefetchList: boolean
}

interface IMessageItem {
  sender: string
  receiver: string
  content: string
  sent_time: string
}

interface IReceivedFilterItem {
  dateFrom?: string
  dateTo?: string
  skip: number
  take: number
  searchValue?: string
  sms_service: string
}

const ReceivedTextHistoryTable: React.FC<Props> = () => {
  const defaultSearchSMSProvider = 'ozeki'
  const [hasMoreData, setHasMoreData] = useState<boolean>(true)
  const [isOpenModalViewDetailItem, setIsOpenModalViewDetailItem] = useState<boolean>(false)
  const [currentMessageMailItemSelected, setCurrentMessageMailItemSelected] =
    useState<IMessageItem>()
  const [listMessageTxt, setListMessageTxt] = useState<IMessageItem[]>([])
  const [searchObject, setSearchObject] = useState<IReceivedFilterItem>({
    searchValue: '',
    skip: listMessageTxt.length,
    take: PAGINATION_DEFAULT.take,
    sms_service: defaultSearchSMSProvider,
  })
  const prevSearchObjectRef = useRef({})
  const [minDateFilter, setMinDateFilter] = useState<Date>()
  const [maxDateFilter, setMaxDateFilter] = useState<Date>()
  const [isFocusSearch, setIsFocusSearch] = useState<boolean>(false)
  const [totalCount, setTotalCount] = useState<number>(0)
  const [disableDownloadBtn, setDisableDownloadBtn] = useState<boolean>(false)
  const [listSMSTemplate , setListSMSTemplate] = useState<ISMSTemplateFile[]>([])
  

  const [
    getReceivedTextData,
    { loading: getReceivedTextDataLoading, fetchMore: fetchMoreForGetReceivedTextData },
  ] = useLazyQuery(GET_RECEIVED_TEXT_QUERY)

  const [
    loadListTemplateForSMS,
  ] = useLazyQuery(LOAD_LIST_TEMPLATE_SMS)

  const handleGetData = async (searchObject: IReceivedFilterItem) => {
    const response = await getReceivedTextData({
      variables: { filter: searchObject },
      fetchPolicy: 'network-only',
    })

    if (!response.data.getReceivedTextData) return

    const { data, total } = response.data.getReceivedTextData

    if (data && total) {
      setListMessageTxt(data)
      setTotalCount(total)
    }
  }

  const fetchMoreDataForMessageHistory = async () => {
    try {
      const variables = {
        filter: {
          ...searchObject,
          skip: listMessageTxt.length,
          take: PAGINATION_DEFAULT.take,
        },
      }
      const response = await fetchMoreForGetReceivedTextData({ variables })
      
      if (!response.data.getReceivedTextData) return

      const { data } = response.data.getReceivedTextData

      if (data.length > 0) {
        setHasMoreData(data.length === PAGINATION_DEFAULT.take)
        const dataState = [...listMessageTxt, ...data]
        setTimeout(() => {
          setListMessageTxt(dataState)
        }, 1000)
      } else {
        setHasMoreData(false)
        return
      }
    } catch (error) {
      notify(MESSAGES.ERROR.E_TRY_AGAIN, STATUS.ERROR)
    }
  }

  const handleCloseTxtInfoDialog = () => {
    setIsOpenModalViewDetailItem(false)
  }

 

  const onHandleClickTxtChatAction = (item: IMessageItem) => {
    setCurrentMessageMailItemSelected(item)
    setIsOpenModalViewDetailItem(true)
    if (listSMSTemplate.length === 0) {
      loadListTemplateForSMS({
        variables: {},
        fetchPolicy: 'no-cache',
      }).then((result) => {
        console.log(result.data)
        setListSMSTemplate(result.data.loadListTemplateForTxt)
      })
    }
  }

  const startDateChange = (value: Date) => {
    setMinDateFilter(value)
    const dateFrom = value ? moment(value).format('YYYY-MM-DD') : ''
    setSearchObject((state) => {
      return { ...state, dateFrom, ...PAGINATION_DEFAULT }
    })
  }
  const endDateChange = (value: Date) => {
    setMaxDateFilter(value)
    const dateTo = value ? moment(value).format('YYYY-MM-DD') : ''
    setSearchObject((state) => {
      return { ...state, dateTo, ...PAGINATION_DEFAULT }
    })
  }
  const handleSearchBox = (value: string) => {
    setSearchObject((state) => {
      return { ...state, searchValue: value.trim(), ...PAGINATION_DEFAULT }
    })
  }

  useEffect(() => {
    if (
      searchObject &&
      JSON.stringify(searchObject) !== JSON.stringify(prevSearchObjectRef.current)
    ) {
      setHasMoreData(true)
      handleGetData(searchObject)
    }
    prevSearchObjectRef.current = searchObject
  }, [searchObject])

  const onClickDownloadCSVBtn = async () => {
    try {
      setDisableDownloadBtn(true)
      const response = await axiosInstance.post('/export/received/text', searchObject, {
        responseType: 'blob',
      })

      const blob = new Blob([response.data])

      // Create a temporary URL for the Blob
      const url = URL.createObjectURL(blob)

      // Create a download link and initiate the file download
      const downloadLink = document.createElement('a')
      downloadLink.href = url
      downloadLink.download = 'receivedText.csv'
      downloadLink.click()
    } catch (error: Error | any) {
      if (isAxiosError(error)) {
        notify(error.message, STATUS.ERROR)
      } else {
        notify('Something wrong', STATUS.ERROR)
      }
    } finally {
      setDisableDownloadBtn(false)
    }
  }

  return (
    <div>
      <div className="flex justify-between mb-3">
        <p className="pt-2 text-headline5A text-neutral-1">Received Text History</p>
        <div className="flex items-end space-x-4">
          <TotalNumberInTable number={totalCount} />
          <ButtonBase
            className="disabled:bg-primary-shade3"
            bgHover="Download detail email job csv"
            onClick={onClickDownloadCSVBtn}
            disabled={disableDownloadBtn}
          >
            Download CSV
          </ButtonBase>
        </div>
      </div>
      <div className="flex w-full mb-5">
        <DateFilterPicker
          className="w-1/4 pr-2"
          setCallBackDateChange={startDateChange}
          maxDate={maxDateFilter}
          defaultDate={moment().subtract(1, 'month').toDate()}
        />
        <DateFilterPicker
          className="w-1/4 pr-2"
          setCallBackDateChange={endDateChange}
          minDate={minDateFilter}
        />
        <div
          className={classNames('w-2/4 rounded-xl border-[2px]', {
            'border-neutral-3': isFocusSearch,
            'border-neutral-5': !isFocusSearch,
          })}
        >
          <SearchInput
            classInput="border-0 w-full"
            setIsFocus={setIsFocusSearch}
            handleSearch={handleSearchBox}
            placehoderText="Search sender phone"
            isHandleSearch={false}
          />
        </div>
      </div>

      <table className="w-full text-left border-2 border-neutral-6 rounded-t-lg overflow-hidden">
        <thead className="bg-primary-shade4 text-body1 text-neutral-2">
          <tr className="w-full">
            {tableHeaderReceivedTxtHistoryTable.map((item: any, idx: number) => (
              <th
                key={idx}
                className={`font-semibold py-5 ${
                  idx === tableHeaderReceivedTxtHistoryTable.length - 1 ? `` : ` pl-2`
                } ${item.headerStyles}`}
              >
                <div className={`flex`}>
                  <span className={`${item.isOneLineRes && 'lg:mt-[-3.5px]'}`}>{item.name}</span>
                  <div className={`${item.isOneLineRes && 'lg:mt-[-3.5px]'}`}></div>
                </div>
              </th>
            ))}
          </tr>
        </thead>
      </table>
      {getReceivedTextDataLoading && <Loading className="relative py-6" height={30} width={30} />}

      {listMessageTxt?.length === 0 && !getReceivedTextDataLoading ? (
        <p className="py-6 text-center text-body1 text-neutral-4">No data available.</p>
      ) : (
        Boolean(
          listMessageTxt !== null && listMessageTxt?.length > 0 && !getReceivedTextDataLoading,
        ) && (
          <InfiniteScroll
            dataLength={listMessageTxt?.length}
            next={fetchMoreDataForMessageHistory}
            hasMore={hasMoreData}
            height={'max-content'}
            style={{ maxHeight: 500 }}
            loader={''}
            endMessage={''}
            className="cus-scrollbar"
          >
            <table key={`table-key`} className="cursor-pointer w-full">
              {listMessageTxt?.map((messageTxt: IMessageItem, index: number) => (
                <tbody key={`table-job-${index}`}>
                  <tr className="h-[72px] w-full hover:bg-neutral-7 pt-5">
                    <td className={` ${tableHeaderReceivedTxtHistoryTable[0].rowStyles}`}>
                      <span>{messageTxt.sender}</span>
                    </td>

                    <td className={`${tableHeaderReceivedTxtHistoryTable[1].rowStyles}`}>
                      <span> {messageTxt?.receiver}</span>
                    </td>
                    <td className={`${tableHeaderReceivedTxtHistoryTable[2].rowStyles}`}>
                      <span>
                        {
                          <Moment format="yyyy-MM-DD HH:mm">
                            {moment.utc(messageTxt.sent_time ?? '')}
                          </Moment>
                        }
                      </span>
                    </td>
                    <td className={`${tableHeaderReceivedTxtHistoryTable[3].rowStyles}`}>
                      <div className="flex w-full">
                        <p
                          dangerouslySetInnerHTML={{ __html: messageTxt.content }}
                          style={{ ...styleJsonPacket }}
                          className={`break-all w-[85%]`}
                        ></p>
                        <div className="w-[15%] flex justify-center">
                          <button
                            title="View Chat"
                            onClick={(e) => {
                              e.stopPropagation()
                              onHandleClickTxtChatAction(messageTxt)
                            }}
                          >
                            <img src={IconViewEmailByAMS} alt="Icon-Hover-Copy" />
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              ))}
            </table>
          </InfiniteScroll>
        )
      )}

      {isOpenModalViewDetailItem && (
        <ChatContentItemDialog
          key={(currentMessageMailItemSelected?.sender || '') + (currentMessageMailItemSelected?.sent_time || '')}
          modalIsOpen={true}
          title="View Txt Detail"
          smsTemplates={listSMSTemplate}
          handleCloseDialog={handleCloseTxtInfoDialog}
          userNumber={currentMessageMailItemSelected?.sender || ''}
        />
      )}
    </div>
  )
}
export default memo(ReceivedTextHistoryTable)
